import $ from "jquery";
import slick from "slick-carousel";

$(() => {
	console.log("Works");
	$(".experience__slider").slick({
		centerMode: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: false,
		loop: true,
		variableWidth: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
					variableWidth: false,
				},
			},
		],
	});

	$(".myths__slider").slick({
		slidesToShow: 2,
		slidesToScroll: 2,
		arrows: false,
		variableWidth: true,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					dots: true,
					variableWidth: false,
				},
			},
		],
	});

	$(".popup__close").on("click", function () {
		$("body").removeClass("show-popup");
	});

	$(".overlay__close").on("click", function () {
		$("body").removeClass("show-overlay");
	});

	$(".experience__btn").on("click", function () {
		const index = $(this).data("id");
		console.log("index", index);
		const $video = $(".overlay__video");
		$video.attr("src", `https://www.youtube.com/embed/${index}?autoplay=1`);
		$("body").addClass("show-overlay");
	});

	$(".overlay").on("click", function () {
		$("body").removeClass("show-overlay");
		const $video = $(".overlay__video");
		$video.attr("src", "");
	});

	$(".webinar__form").on("submit", function (e) {
		e.preventDefault();
		const val = $(".webinar__input").val();
		$.ajax({
			type: "POST",
			url: "/save_quest/",
			data: {
				question: val,
			},
			success: function (resp) {
				const data = JSON.parse(resp);
				if (data.error && data.error.length > 0) {
				} else {
					$("body").addClass("show-popup");
					$(".webinar__input").val("");
				}
			},
		});
	});
});



// WEBPACK FOOTER //
// ./app/scripts/app.js